module.exports = __webpack_public_path__ + "images/ideal.bba24c1aa8f06ddce41d5bd6ccdac2c2.png";